import { useNavigate } from 'react-router-dom';
import { Target } from 'lucide-react';
import Button from '../../common/Button.js';

const LocationTargetsButton = () => {
  const navigate = useNavigate();
  return (
    <Button
      variant="secondary"
      mobileIconOnly
      mobileLabel="Branch performance"
      icon={Target}
      onClick={() => navigate('/location-targets')}
    >
      Branch performance
    </Button>
  );
};

export default LocationTargetsButton;
